import { Box, Divider, Grid } from '@mui/material'
import React, { useState } from 'react'
import { useTheme } from '@mui/styles'
import { TextBold, TextRegular } from '../../../commonComponents/TextStyling'

import { showToast } from '../../../utils/AppHelper'
import { useLocation, useNavigate } from 'react-router-dom'
import serverData from '../../../api/ServerData'
import ImageComponent from '../../../commonComponents/ImageComponent'
import AppButton from '../../../commonComponents/AppButton'

export default function JobDetails ({ candidateState, changeState }) {
  const location = useLocation()
  const navigate = useNavigate()

  const [loadingBtn, setLoadingBtn] = useState(false)

  const query = new URLSearchParams(location.search)
  const token = query.get('token')

  var theme = useTheme()

  return (
    <Grid container>
      <Grid
        item
        xs={12}
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <TextBold
          style={{
            fontSize: '22px'
          }}
        >
          Hey, {candidateState?.candidateFirstName}
        </TextBold>
        <TextRegular
          style={{
            color: theme.palette.text.secondary
          }}
        >
          Thanks for taking the time to approve your job application. It's a one
          click process.
        </TextRegular>
      </Grid>

      <Divider
        style={{
          width: '100%',
          margin: '24px 0px'
        }}
      />

      <Grid
        item
        style={{
          display: 'flex',
          justifyContent: 'center',
          border: `1px solid ${theme.palette.border.main}`,
          width: '65px',
          height: '65px',
          borderRadius: '16px',
          overflow: 'hidden',
          padding: '8px',
          objectFit: 'contain'
        }}
      >
        <ImageComponent
          alt='company logo'
          src={candidateState.profilePicture}
          style={{}}
        />
      </Grid>

      <Grid
        item
        style={{
          display: 'flex',
          width: '79%',
          alignItems: 'center'
        }}
      >
        <Grid container direction={'column'} style={{ paddingLeft: '16px' }}>
          <Grid item>
            <TextBold style={{ fontSize: '18px' }}>
              {candidateState?.jobTitle}
            </TextBold>
          </Grid>
          <Grid item>
            <TextRegular>
              {candidateState.companyname}, {candidateState.city},{' '}
              {candidateState.state} - {candidateState.countryName} [
              {candidateState.workLocationTypeName}]
            </TextRegular>
          </Grid>
        </Grid>
      </Grid>

      <Divider
        style={{
          width: '100%',
          margin: '24px 0px'
        }}
      />

      <Grid item xs={12}>
        <Grid container style={{}}>
          <Grid item xs={12}>
            <TextBold
              style={{
                fontSize: '16px'
              }}
            >
              Job Description
            </TextBold>
          </Grid>
          <Grid item xs={12}>
            <TextRegular>
              <Box
                dangerouslySetInnerHTML={{
                  __html: candidateState.jobDescription
                }}
              />
            </TextRegular>
          </Grid>
        </Grid>
      </Grid>

      <Divider
        style={{
          width: '100%',
          margin: '24px 0px'
        }}
      />

      <Grid
        item
        xs={12}
        style={{
          display: 'flex',
          justifyContent: 'center',
          padding: 0
        }}
      >
        <AppButton
          style={{
            textTransform: 'none',
            width: 'fit-content'
          }}
          name={'Approve your job application'}
          disabled={false}
          loading={loadingBtn}
          onClick={() => {
            setLoadingBtn(true)
            serverData.approveCandidateApplication(
              { token },
              data => {
                if (data?.status) {
                  changeState(2)
                } else {
                  navigate('/')
                }
                setLoadingBtn(false)
              },
              error => {
                setLoadingBtn(false)
                showToast(error.statusText)
              }
            )
          }}
        />
      </Grid>
    </Grid>
  )
}
